import { generatePath } from 'react-router-dom'
import {
  PAYMENT_PLANS_CREATE,
  PAYMENT_PLAN_UPDATE,
  PAYMENT_PLAN_DESTROY,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestPaymentPlanCreate = async ({
  paymentMethodId,
  params,
}) => {
  const path = generatePath(PAYMENT_PLANS_CREATE, { paymentMethodId })

  const response = await request.post(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestPaymentPlanUpdate = async ({
  paymentMethodId,
  id,
  params,
}) => {
  const path = generatePath(PAYMENT_PLAN_UPDATE, { paymentMethodId, id })

  const response = await request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestPaymentPlanDestroy = async ({ paymentMethodId, id }) => {
  const path = generatePath(PAYMENT_PLAN_DESTROY, { paymentMethodId, id })

  const response = await request.delete(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}
